<template>
  <div>
    <facit-header></facit-header>
      <div class = "profile-div col-12">
        <h5 class="mt-3 mb-3"> <a @click="users()" class="Userlink">
                                  User Management</a> / User License Detail </h5>
        <br><br>
        <b-table  striped hover
                  show-empty
                  empty-text="There is no user history to show"
                  :fields="tableFields"
                  :items="history"
                  :current-page="currentPage"
                  :per-page="perPage">
        </b-table>
        <br>
        <b-pagination align="right"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      v-model="currentPage"
                      class="my-0" />
      </div>
  </div>
</template>

<script>
import API from '@/api';
import FacitHeader from '@/components/header';
import moment from 'moment';

export default {
  name: 'userManagement',
  components: { FacitHeader },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      history: null,
      userSettingsModal: false,
      tableFields: [
        {
          key: 'productKey',
          label: 'Product Key',
          sortable: true,
        },
        {
          key: 'licenceKey',
          label: 'Licence Key',
          sortable: true,
        },
        {
          key: 'issueDate',
          label: 'Issue Date',
          sortable: true,
          formatter: (value) => {
            return moment(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'expiryDate',
          label: 'Expiry Date',
          sortable: true,
          formatter: (value) => {
            return moment(value).format('DD-MM-YYYY');
          },
        },
      ],
    };
  },
  async created() {
    const userId = this.$route.query.id;
    this.getHistory(userId);
  },
  methods: {
    async getHistory(userId) {
      this.history = await API.get(`Accounts/${userId}/Licence?filter={"order": "issueDate DESC"}`);
    },
    users() {
      this.$router.push('/admin/users');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #d6700a;
}

input:focus + .slider {
  box-shadow: 0 0 1px #d6700a;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
}
.switch input {
  display:none;
}
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.page-item.active .page-link {
  z-index: 1;
    color: #fff;
    background-color: #6610f2 !important;
    border-color: #6610f2 !important;
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}
.Userlink {
  color: #df8031 !important;
  text-decoration: none !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/userHistory.vue